var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('h5',_vm._l((_vm.getValores()),function(valor,i){return _c('span',{key:i,staticClass:"badge badge-pill badge-info"},[_vm._v(_vm._s(valor.nombre))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }